import { render, staticRenderFns } from "./SurveyAlreadySubmitted.vue?vue&type=template&id=5e68c09e&"
import script from "./SurveyAlreadySubmitted.vue?vue&type=script&lang=js&"
export * from "./SurveyAlreadySubmitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports